'use strict';

const Mn = require('backbone.marionette');
const Tooltip = require('common/ui/view/behavior/tooltip');
const CommentReactionCreateService = require('communication/app/service/comment/reaction/create');
const CommentReactionRemoveService = require('communication/app/service/comment/reaction/remove');
const ReactionItemTemplate = require('communication/ui/comment/template/reaction-item.hbs');
const ReactionContainerTemplate = require('communication/ui/comment/template/reaction-container.hbs');

class ReactionItemView extends Mn.View {
    get tagName() {
        return 'div';
    }

    get className() {
        return 'comment-reaction-item-container';
    }

    get template() {
        return ReactionItemTemplate;
    }

    get behaviors() {
        return [Tooltip];
    }

    events() {
        return {
            'click .toggle-reaction': 'toggleReaction'
        };
    }

    modelEvents() {
        return {
            'change:actions': 'render'
        };
    }

    templateContext() {
        const mappings = this.getOption('mappings');
        const faClass = mappings[this.model.name] || 'fa-question';

        const reactionUsers = this.model.actions.map(action => {
            return {
                name: action.getUserName()
            };
        });

        return {
            userReacted: this.userReacted(),
            faClass: faClass,
            reactionUsers: reactionUsers,
            reactionUsersNum: reactionUsers.length
        };
    }

    userReacted() {
        const context = this.getOption('context');

        return this.model.actions.find(action => {
            return context.getUser().id === action.getUserID();
        });
    }

    toggleReaction() {
        const reactionName = this.model.name;

        if(this.userReacted()) {
            this.triggerMethod('remove:reaction', reactionName);
        } else {
            this.triggerMethod('add:reaction', reactionName);
        }
    }

}

class ReactionCollectionView extends Mn.CollectionView {
    constructor(options) {
        super(options);

        this.childView = ReactionItemView;
    }

    childViewOptions() {
        return {
            context: this.getOption('context'),
            mappings: this.getOption('mappings')
        };
    }

    childViewTriggers() {
        return {
            'add:reaction': 'add:reaction',
            'remove:reaction': 'remove:reaction'
        };
    }

    onAddChild() {
        this.triggerMethod('comment:reaction:add');
    }
}

class ReactionContainerView extends Mn.View {
    get tagName() {
        return 'div';
    }

    get className() {
        return 'comment-reaction-container';
    }

    get template() {
        return ReactionContainerTemplate;
    }

    regions() {
        return {
            reactions: '.reactions'
        };
    }

    childViewTriggers() {
        return {
            'comment:reaction:add': 'comment:reaction:add'
        };
    }

    childViewEvents() {
        return {
            'add:reaction': 'addReaction',
            'remove:reaction': 'removeReaction'
        };
    }

    onRender() {
        const context =this.getOption('context');
        const mappings = this.getMappings();

        this.showChildView('reactions', new ReactionCollectionView({
            collection: this.model.getReactions(),
            context: context,
            mappings: mappings
        }));
    }

    // TODO: 複数種類のリアクションに対応しやすいように要リファクタリング
    addReaction(reactionName) {
        const context = this.getOption('context');
        const project = context.getProject();
        const comment = this.model;
        const userKey = context.getUser().getKey();

        new CommentReactionCreateService(project, comment, userKey, reactionName).execute();
    }

    removeReaction(reactionName) {
        const context = this.getOption('context');
        const project = context.getProject();
        const comment = this.model;
        const userKey = context.getUser().getKey();

        new CommentReactionRemoveService(project, comment, userKey, reactionName).execute();
    }

    addThumbsUpReaction() {
        this.addReaction('thumbs_up');
    }

    getMappings() {
        return {
            thumbs_up: 'fa-thumbs-up'
        };
    }
}

module.exports = ReactionContainerView;



// WEBPACK FOOTER //
// ./communication/ui/comment/view/reaction.js